import { createContext } from "react";

export const ViewerContext = createContext();
